import React from 'react';
import { Sparkles, Heart, Zap, Instagram, Linkedin, Mail, MapPin, Youtube } from 'lucide-react';
import { socialLinks } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-white py-8 relative" role="contentinfo">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <h2 className="text-base md:text-lg font-bold text-stone-800 mb-0.5">
            @techbaenae
          </h2>
          
          {/* Location */}
          <div className="flex justify-center items-center gap-1 mb-4 text-stone-500">
            <MapPin className="w-2.5 h-2.5" aria-hidden="true" />
            <span className="text-[9px] tracking-wider">somewhere data dreaming</span>
          </div>
          
          {/* Featured in */}
          <div className="mb-4">
            <p className="text-[8px] text-stone-500 uppercase tracking-[0.2em] mb-1">featured in</p>
            <div className="flex justify-center items-center gap-2 text-[10px] md:text-xs font-medium text-stone-700">
              <span>Afrotech</span>
              <span className="text-stone-300" aria-hidden="true">·</span>
              <span>Vogue</span>
              <span className="text-stone-300" aria-hidden="true">·</span>
              <span>Essence</span>
            </div>
          </div>
          
          {/* Social links */}
          <nav className="flex justify-center items-center gap-2 mb-4" aria-label="Footer social links">
            <a
              href={socialLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="p-1.5 rounded-full bg-stone-100 hover:bg-pink-100 transition-colors group focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2"
              aria-label="Follow on Instagram"
            >
              <Instagram className="w-3 h-3 text-stone-600 group-hover:text-pink-500 transition-colors" aria-hidden="true" />
            </a>
            <a
              href={socialLinks.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="p-1.5 rounded-full bg-stone-100 hover:bg-blue-100 transition-colors group focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              aria-label="Connect on LinkedIn"
            >
              <Linkedin className="w-3 h-3 text-stone-600 group-hover:text-blue-500 transition-colors" aria-hidden="true" />
            </a>
            <a
              href={socialLinks.email}
              className="p-1.5 rounded-full bg-stone-100 hover:bg-orange-100 transition-colors group focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
              aria-label="Send email"
            >
              <Mail className="w-3 h-3 text-stone-600 group-hover:text-orange-500 transition-colors" aria-hidden="true" />
            </a>
            <a
              href={socialLinks.youtube}
              target="_blank"
              rel="noopener noreferrer"
              className="p-1.5 rounded-full bg-stone-100 hover:bg-red-100 transition-colors group focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
              aria-label="Watch on YouTube"
            >
              <Youtube className="w-3 h-3 text-stone-600 group-hover:text-red-500 transition-colors" aria-hidden="true" />
            </a>
          </nav>
          
          {/* Decorative symbols */}
          <div className="flex justify-center items-center gap-2 mb-4 text-stone-400 text-[10px]" aria-hidden="true">
            <Zap className="w-2.5 h-2.5" />
            <span role="img" aria-label="dog">🐶</span>
            <Heart className="w-2.5 h-2.5" fill="currentColor" />
            <span role="img" aria-label="strawberry">🍓</span>
            <Sparkles className="w-2.5 h-2.5" />
          </div>
          
          <p className="text-[9px] text-stone-500">
            © {new Date().getFullYear()} techbaenae
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
